<template>
  <div
    class="dropdown"
    :class="{'is-active': showDropDown}"
    @click="showDropDown = !showDropDown">
    <div class="dropdown-trigger">

        <o-field v-if="useTextInput">
            <o-input 
                :placeholder="starterText" 
                v-model="dropdownText" 
                :icon-right="dropdownIcon" 
                icon-pack="fa fas" 
                class="input" 
                type="text" 
                @keyup="filterItems"
                :disabled="isDisabled"
            />
        </o-field>

        <button v-else :disabled="isDisabled" class="button slightly-rounded" aria-haspopup="true" aria-controls="dropdown-menu3">
            <span>{{ dropdownText || starterText }}</span>
                <span class="icon is-small" >
                <i :class="dropdownIcon" aria-hidden="true"></i>
            </span>
        </button>

    </div>
    <div
      class="dropdown-menu"
      id="dropdown-menu3"
      role="menu">
      <div
        class="dropdown-content"
        :class="{'dropdown-content-fold': itemDicts.length > 10}"
        v-if="showDropDownList">
        <span v-for="item in itemDicts">
          <a @click="onSelected(item)" class="dropdown-item">
            {{ item.label }}
          </a>
        </span>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from 'vue'
export default {
    name: 'DropDown',
    data () {
        return {
            showDropDown: false,
            dropdownText: null,
            filteredItems: '',
        }
    },
    props: {
        "items": Array,
        "starterText": String,
        "switchToSelected": Boolean,
        "customIconClass": String,
        "disabled": Boolean,
        "useTextInput": {
            type: Boolean,
            default: false
        },
        "updateSelected": String,
    },
    emits: ['selected'],
    mounted() {
        // Add a click event listener to the document body
        document.addEventListener('click', this.handleDocumentClick)
        // Initialize dropdownText with updateSelected value
        if (this.updateSelected) {
            this.dropdownText = this.updateSelected
        }
    },
    beforeDestroy() {
        // Remove the click event listener when the component is destroyed
        document.removeEventListener('click', this.handleDocumentClick)
    },
    watch: {
        updateSelected(newValue) {
            // Update dropdownText when updateSelected prop changes
            this.dropdownText = newValue
            this.filteredItems = []
        }
    },
    methods: {
        handleDocumentClick(event) {
            // Check if the click target is outside the dropdown
            const dropdownElement = this.$el
            if (!dropdownElement.contains(event.target)) {
                // Clicked outside the dropdown, close it
                this.showDropDown = false
            }
        },
        fixItems(items){
            return items.map((item) => {
                if (typeof item === 'object'){
                    return item
                } else {
                    return {label: item, value: item}
                }})
        },
        onSelected(item) {
            if (this.switchToSelected == null || this.switchToSelected) {
                this.dropdownText = item.label
            }
            this.$emit("selected", item.value)
        },
        filterItems() {
            // Every time the user types, show the dropdown list
            this.showDropDown = true
            /* Set the selected value here in case the user wants to
             only type it and not select it from the dropdown.
             Also addresses the user clearing their input */
            this.$emit("selected", this.dropdownText.toLowerCase())

            if (this.dropdownText) {
                if (this.dropdownText.length > 2) {
                    const searchText = this.dropdownText.toLowerCase()
                    this.filteredItems = this.items.filter(item => item.toLowerCase().includes(searchText))
                }
            } else {
                // Trigger reactivity for showDropDownList by assigning a new array
                this.filteredItems = []
            }
        },
    },
    computed: {
        itemDicts(){
            if (this.filteredItems) {
                return this.fixItems(this.filteredItems)
            } else {
                return this.fixItems(this.items)
            }
        },
        dropdownIcon() {
            if (this.customIconClass) {
                return this.customIconClass
            } else {
                return "fas fa-angle-down"
            }
        },
        showDropDownList() {
            if (this.useTextInput) {
                return this.filteredItems.length > 0 && this.dropdownText !== null
            } else {
                return this.items !== null
            }
        },
        isDisabled() {
            return this.items.length === 0 || this.disabled
        }
    }
}
</script>

<style>
.dropdown-content-fold {
    max-height: 13em;
    overflow-y: scroll;
}
</style>
